import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';

export class SupervisorSignoff extends Component {
    static displayName = SupervisorSignoff.name;
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: false,
            sending: false,
            headerTitle: "Supervisor Signoff",
            alertMessage: "",
            passwordText: "",
            usernameText: "",
            staffId: "",
            sourceRoute: props.location.state,
        };
        this.history = props.history;
    }

    componentDidMount() {
        this.populateData();
    }

    goto(page, data) {
        this.history.push({
            pathname: page,
            state: data
        });
    }

    renderDropdown(data) {
        return (<select
            className="form-select form-control"
            name="selUsername"
            aria-label=".form-select-lg example"
            onChange={(e) => {
                this.setState({ staffId: e.target.value, passwordText: "" });
            }}
            readOnly={this.state.sending}
        >
            {data.map(row =>
                <option key={row.id} value={row.id}>{row.Staff_Name}</option>
            )}
        </select>)
    }

    render() {

        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : "";

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";
        return (

            <div className="">
                {alertMessage}
                <MyHeading>{this.state.headerTitle}</MyHeading>
                {contents}
                <div className="form-group">
                    <label htmlFor="selUsername">Username</label>
                    {this.renderDropdown(this.state.data)}
                </div>

                <div className="form-group">
                    <label htmlFor="txtPasword">Password</label>
                    <input
                        type="password"
                        className="form-control"
                        name="txtPasword"
                        id="txtPasword"
                        value={this.state.passwordText}
                        onChange={(e) => {
                            this.setState({ passwordText: e.target.value });
                        }}
                        readOnly={this.state.sending}
                    />
                </div>

                <div className="container">
                    <div className="row form-group">
                        <button type="button" className="btn btn-success col-12 mb-2" disabled={this.state.loading} onClick={() => { this.doLogin(); }}>Approve</button>
                    </div>
                </div>
                <div className="container">
                    <div className="row form-group">
                        <button type="button" className="btn btn-danger col-12 mb-2" disabled={this.state.loading} onClick={() => { this.goBack(); }}>Cancel</button>
                    </div>
                </div>
            </div>

        );

    }

    goBack() {
        var sourceRoute = this.state.sourceRoute;
        this.goto(sourceRoute.backUrl, { selectedShipment: sourceRoute.selectedShipment });
    }

    async approve() {
        var sourceRoute = this.state.sourceRoute;
        if (sourceRoute.backUrl === 'ScanCarton') {
            this.setState({ loading: true });
            const submitRequest = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    Operation: "COMPL_RCPT",
                    Id: sourceRoute.selectedShipment.shipment_ref,
                    UpdateValue1: this.state.staffId,
                    UpdateValue2: sourceRoute.selectedShipment.scanItemsInUnknown == true ? "1" : "0",
                    UpdateValue3: ""
                })
            };

            const response = await fetch('api/MXDock/UpdateMXDockDetails', submitRequest);
            const result = await response.json();
            if (result.success) {
                this.setState({ alertMessage: "", loading: false });
                if (sourceRoute.selectedShipment.scanItemsInUnknown) {
                    this.goto(sourceRoute.nextUrl, { selectedShipment: sourceRoute.selectedShipment });
                }
                else {
                    this.goto('MXDockChooseShipment', null);
                }

            } else {
                this.setState({ alertMessage: result.errorMessage, loading: false });
            }
        }
        if (sourceRoute.backUrl === 'UnknownCarton') {
            this.setState({ loading: true });
            const submitRequest = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    Operation: "COMPL_RCPT",
                    Id: sourceRoute.selectedShipment.shipment_ref,
                    UpdateValue1: this.state.staffId,
                    UpdateValue2: "0",
                    UpdateValue3: ""
                })
            };
            const response = await fetch('api/MXDock/UpdateMXDockDetails', submitRequest);
            const result = await response.json();
            if (result.success) {
                this.setState({ alertMessage: "", loading:false });
                if (sourceRoute.selectedShipment.scanItemsInUnknown) {
                    this.goto(sourceRoute.nextUrl, null);
                }
                else {
                    this.setState({ alertMessage: result.errorMessage, loading: false });
                }
            } else {
                this.setState({ alertMessage: result.errorMessage, loading: false });
            }
        }
    }




    async doLogin() {
        if (this.state.staffId == "" || this.state.passwordText == "") {
            this.setState({ alertMessage: "Enter username and password" });
            return;
        }

        const response = await fetch(`api/MXDock/SupervisorApproval?staffId=${this.state.staffId}&password=${this.state.passwordText}`);
        const result = await response.json();
        if (result.success) {
            this.setState({ alertMessage: "" });
            this.approve();
        } else {
            this.setState({ alertMessage: "Incorrect username or password" });
        }
    }

    async populateData() {
        this.setState({ loading: true });
        let url = `api/MXDock/GetActiveTimeSheetUsers`;
        const response = await fetch(url, {
        });
        const result = await response.json();
        if (result.success) {
            this.setState({
                data: result.data, alertMessage: ""
            });
        }
        else {
            this.setState({ alertMessage: "Incorrect username or password" });
        }

        this.setState({ loading: false });
    }
}

export default SupervisorSignoff;